import React from 'react';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

type ChallengeRankingEntry = {
  rank: number;
  user: {
    id: string;
    firstname?: string;
    lastname?: string;
    email: string;
  };
  totalScore: number;
  compobotScore: number;
  quizScore: number;
  logCount: number;
};

type Props = {
  data: ChallengeRankingEntry[];
};

const ChallengeRankingTable: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) return null;

  const getDisplayName = (user: ChallengeRankingEntry['user']) => {
    const fullName = `${user.lastname ?? ''} ${user.firstname ?? ''}`.trim();
    return fullName
      ? `${fullName} (${user.email})`
      : user.email; // ha nincs név, csak email
  };

  return (
    <>
      <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
        Toplista
      </Typography>

      <Card sx={{ width: '100%', overflowX: 'auto', mb: 5 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Név</TableCell>
                <TableCell align="right">Összpont</TableCell>
                <TableCell align="right">CompoBot</TableCell>
                <TableCell align="right">Kvíz</TableCell>
                <TableCell align="right">Logok száma</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((entry) => (
                <TableRow key={entry.user.id}>
                  <TableCell>{entry.rank}</TableCell>
                  <TableCell>{getDisplayName(entry.user)}</TableCell>
                  <TableCell align="right">{entry.totalScore}</TableCell>
                  <TableCell align="right">{entry.compobotScore}</TableCell>
                  <TableCell align="right">{entry.quizScore}</TableCell>
                  <TableCell align="right">{entry.logCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
};

export default ChallengeRankingTable;